<template>
    <v-app id="v-app">
        <AppNavigation v-if="route.name !== 'redirecting'" />
        <v-main v-if="isMounted">
            <router-view :key="routePath" />
            <app-alerts />
        </v-main>
        <AppFooter v-if="route.name !== 'redirecting'" />
    </v-app>
</template>

<script setup lang="ts">
import AppAlerts from '@/components/AppAlerts.vue'
import AppNavigation from '@/components/navigations/AppNavigation.vue'
import AppFooter from '@/components/navigations/AppFooter.vue'
import { computed, inject, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'
import { ApiPluginInterface } from '@/plugins/api-plugin'
import useActivityTracker from '@/composables/useActivityTracker'

const api = inject<ApiPluginInterface>('api')
const storeAuth = useAuthStore()
storeAuth.loadRoles(api).then()
if (api) useActivityTracker(useRouter(), api.userActivity)

const isMounted = ref(false)
const route = useRoute()
const routePath = computed(() => route.path)

onMounted(() => {
    isMounted.value = true
})
</script>

<style lang="scss">
@import 'sass/main';
</style>
